/* unplugin-vue-components disabled */import { render } from "./center.vue?vue&type=template&id=4e659e12&scoped=true"
import script from "./center.vue?vue&type=script&lang=js"
export * from "./center.vue?vue&type=script&lang=js"

import "./center.vue?vue&type=style&index=0&id=4e659e12&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e659e12"]])

export default __exports__